export const ORDER_STATUSES = {
  ABANDONED: 'abandoned',
  CANCELED: 'canceled',
  PAID: 'paid',
  REFUSE: 'refuse',
  WAITING: 'waiting',
  REFUND: 'refund',
  PARTIAL: 'partial',
} as const;

export type OrderStatus = typeof ORDER_STATUSES[keyof typeof ORDER_STATUSES];
